import {
  TCompanyReq,
  TCompanyRes,
  TGetImageReq,
  TStoreRes,
} from "@models/layout";
import { TAxiosResponse } from "types";
import { axiosInstance } from "./axiosInstance";

const layoutApi = {
  getCompanies: async () => {
    const url = "api/v1/company";
    const response: TAxiosResponse<TCompanyRes[]> = await axiosInstance.get(
      url
    );

    return response;
  },

  getStoresByCompany: async (payload: TCompanyReq) => {
    const url = "/api/v1/store";
    const response: TAxiosResponse<TStoreRes[]> = await axiosInstance.get(
      url,
      {
        params: {
          CompanyCode: payload.companyCode || undefined,
        },
      }
    );

    return response;
  },

  getLayoutImage: async (payload: TGetImageReq) => {
    const url = `Store/map?CompanyCode=${payload.companyCode}&StoreCode=${payload.storeCode}`;
    const response: TAxiosResponse<TLayoutImageRes> = await axiosInstance.get(
      url
    );

    return response;
  },
};

export { layoutApi };

type TLayoutImageRes = {
  mapName: string;
  binaryData: string;
  contentType: string;
};
